module.exports = __webpack_public_path__ + "static/media/img_succession_planning_01.c592a5f3.png";